import moment from 'moment'

export type DashboardDataType = 'month' | 'daily' | 'year'

export const formatDashboardStartDate = (date: Date): string =>
  moment(date)
    .tz('Asia/Bangkok')
    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    .format('YYYY-MM-DDTHH:mm:ss.SSSZ')

export const formatDashboardEndDate = (date: Date): string =>
  moment(date)
    .tz('Asia/Bangkok')
    .set({ hour: 23, minute: 59, second: 59, millisecond: 999 })
    .format('YYYY-MM-DDTHH:mm:ss.SSSZ')
